import { render, staticRenderFns } from "./BusinessMemberPrescriptionChangeStatus.vue?vue&type=template&id=52055e39"
import script from "./BusinessMemberPrescriptionChangeStatus.vue?vue&type=script&lang=js"
export * from "./BusinessMemberPrescriptionChangeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports